import React, { createContext, useContext } from "react";
import propertyDetailAdapter, {
  PropertyDetailAdapterReturn,
} from "../adapters/propertyDetail.adapter";

interface DetailPropertyContextReturn {
  propertyDetail: PropertyDetailAdapterReturn;
}

const DetailPropertyContext = createContext<DetailPropertyContextReturn>(
  {} as DetailPropertyContextReturn
);

export const DetailPropertyProvider: React.FC<{
  children: React.ReactNode;
  data: any;
  url: any;
}> = ({ children, data, url }) => {
  const propertyDetail = propertyDetailAdapter({ ...data, url });
  return (
    <DetailPropertyContext.Provider value={{ propertyDetail }}>
      {children}
    </DetailPropertyContext.Provider>
  );
};

export const useDetailPropertyContextHook = () => {
  const context = useContext(DetailPropertyContext);
  if (!context) {
    throw new Error(
      "useDetailPropertyContext must be used within a DetailPropertyProvider"
    );
  }
  return context;
};
